export const minDistanceHouse = 10;
export const maxDistanceHouse = 30;

export const minDistanceTile = 0.5;
export const maxDistanceTile = 3;

export const rotationAngleInRad = (15 * Math.PI) / 180;
